// import { createStore, applyMiddleware } from 'redux';
// import logger from 'redux-logger';
// import promise from 'redux-promise-middleware';
// import thunk from 'redux-thunk'
// import reducers from './reducers'

// const middleware = applyMiddleware(logger, promise(), thunk)

// export default createStore(reducers, middleware);

import { createStore } from 'redux';
// import logger from 'redux-logger';
import reducers from './reducers'
import middleware from './middleware'

export default createStore(reducers, middleware);
